import React, { useEffect, useState } from 'react';
import { Button, IconButton, Paper } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import CloseIcon from '@mui/icons-material/Close';

export function AccountPanel({ account, t }) {
  const authError = new URLSearchParams(window.location.search).has('authError');
  return (
    <div className="accountPanel">
      {account.user ? <>
        <span className="accountName">{account.user.name || account.user.email}</span>
        <span className="accountStatus" role="status">{t(`account_${account.status}`)}</span>
        {['syncError', 'saving'].includes(account.status) && <Button onClick={account.retry}>{t('syncRetry')}</Button>}
        {account.status === 'conflict' && <>
          <Button onClick={() => account.resolveConflict(true)}>{t('keepLocal')}</Button>
          <Button onClick={() => account.resolveConflict(false)}>{t('loadRemote')}</Button>
        </>}
        {account.status === 'expired' && <Button onClick={account.login}>{t('googleLogin')}</Button>}
        <Button onClick={account.logout} disabled={account.status === 'loading'}>{t('logout')}</Button>
      </> : <>
        <Button className="hiitButton" startIcon={<GoogleIcon />} disabled={!account.enabled} onClick={account.login}>{t('googleLogin')}</Button>
        <span className="accountStatus">{t(account.status === 'syncError' ? 'account_syncError' : account.enabled ? 'accountHint' : account.status === 'loading' ? 'account_loading' : 'googleSetupRequired')}</span>
        {account.status === 'syncError' && <Button onClick={account.retry}>{t('syncRetry')}</Button>}
      </>}
      {(authError || account.status === 'loginError') && <p role="alert">{t('loginFailed')}</p>}
    </div>
  );
}

export function SharedPlanDialog({ apiBase, t, focusMeta, onImport, canImport = true }) {
  const [id] = useState(() => new URLSearchParams(window.location.search).get('sharedPlan'));
  const [open, setOpen] = useState(Boolean(id));
  const [plan, setPlan] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (!id) return;
    const controller = new AbortController();
    fetch(`${apiBase.replace(/\/$/, '')}/api/shared-plans/${encodeURIComponent(id)}`, { signal: controller.signal })
      .then((response) => { if (!response.ok) throw new Error('not_found'); return response.json(); })
      .then((result) => setPlan(result.plan))
      .catch((error) => { if (error.name !== 'AbortError') setError(true); });
    return () => controller.abort();
  }, [id, apiBase]);
  const close = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('sharedPlan');
    window.history.replaceState({}, '', url);
    setOpen(false);
  };
  if (!open) return null;
  return <div className="miniOverlayWrap" onClick={close}>
    <Paper className="miniOverlay sharedPlanPreview" onClick={(event) => event.stopPropagation()}>
      <div className="miniOverlayHead"><div className="miniOverlayTitle">{t('sharedPlan')}</div><IconButton aria-label={t('ariaClose')} onClick={close}><CloseIcon /></IconButton></div>
      {error ? <p role="alert">{t('sharedPlanMissing')}</p> : !plan ? <p role="status">{t('account_loading')}</p> : <>
        <h3>{plan.title}</h3>
        <ol>{plan.exercises.map((entry, index) => <li key={index}>
          {focusMeta[entry.focus || 'full']?.emoji} {entry.name}
          {entry.supersetExercise && <> + {focusMeta[entry.supersetExercise.focus || 'full']?.emoji} {entry.supersetExercise.name}</>}
        </li>)}</ol>
        <Button className="hiitButton" disabled={!canImport} onClick={() => { onImport(plan); close(); }}>{t('importPlan')}</Button>
      </>}
    </Paper>
  </div>;
}
